import { Typography, Box } from '@mui/material'
import theme from 'lib/theme'
import { Fragment } from 'react'
import { DeliveriesForPlace } from 'types/model/order'
import { OrderItem, WarningTimeBox } from './elements'
import { outOfSlot, getDriverPosition } from './utils'
import { ListItem } from './ListItem'

const ShipmentOrdersList = ({ orders }: { orders: DeliveriesForPlace[] }) => {
  const driverPosition = getDriverPosition(orders)

  return (
    <>
      {orders.map((order) => {
        const shipment = Boolean(order.shipmentData[0])
          ? order.shipmentData[0].shipmentOrders
          : null

        const index = shipment
          ? shipment.findIndex(
              (shipment) => shipment.orderId === Number(order.parts[0].id)
            )
          : -1

        const finishAt =
          order.shipmentData &&
          order.shipmentData[0] &&
          order.shipmentData[0].shipmentRoute[index] !== null
            ? order.shipmentData[0].shipmentRoute[index]?.finishAt
            : null

        const endTime = index > -1 ? finishAt?.substring(11, 16) : null

        const deliveryOutOfSlot = outOfSlot(finishAt, order.orderDeliveryTimes)

        return (
          <Fragment key={order.visibleId + order.parts[0].id}>
            {driverPosition &&
              order.parts[0].id === driverPosition.parts[0].id && (
                <Box
                  margin={`${theme.spacing(2)} ${theme.spacing(10)}`}
                  pt={1}
                  pb={1}
                  sx={{
                    backgroundColor: theme.palette.commonColors.white,
                    position: 'relative',
                  }}>
                  <Box
                    sx={{
                      height: '12px',
                      width: '12px',
                      borderRadius: '50%',
                      backgroundColor: order.color,
                      boxShadow: `0 0 0 6px ${order.color}40`,
                      position: 'relative',
                      zIndex: 1000,
                    }}
                  />
                </Box>
              )}
            <OrderItem
              data-cy='order not in planning'
              display='flex'
              alignItems='center'
              smallPadding
              defaultCursor
              hideBorders>
              <Box minWidth='50px'>
                {deliveryOutOfSlot ? (
                  <WarningTimeBox>
                    <Typography variant='body2'>{endTime}</Typography>
                  </WarningTimeBox>
                ) : (
                  <Typography
                    variant='body2'
                    sx={{
                      color: theme.palette.text.secondary,
                    }}>
                    {endTime}
                  </Typography>
                )}
              </Box>
              <Box
                zIndex={3}
                bgcolor='white'
                height='100%'
                width='100%'
                display='flex'
                alignItems='center'>
                <ListItem
                  color={order.color}
                  routeName={order.routeName}
                  routeNameIndex={index + 1}
                  endTime={order.orderDeliveryTimes.endTime}
                  startTime={order.orderDeliveryTimes.startTime}
                  status={order.parts[0].status}
                  partId={order.parts[0].id}
                  deliveryId={order.parts[0].deliveryId}
                  visibleId={order.parts[0].visibleId}
                />
              </Box>
            </OrderItem>
          </Fragment>
        )
      })}
    </>
  )
}

export default ShipmentOrdersList
